export default __webpack_public_path__ + "static/media/clock2.e522f0af.svg";